<template>
  <BaseEmptyState class="empty-state-icon-alt w-full bg-whiteOverride">
    <template v-slot:icon>
      <div>
        <BulkSendIcon />
      </div>
    </template>
    <template v-slot:title>
      <h2 class="text-center">{{ $t('ui.bulkSend.emptyState.upsellBulkSends.title') }}</h2>
    </template>
    <template v-slot:content>
      <p class="text-center">{{ $t('ui.bulkSend.emptyState.upsellBulkSends.info') }}</p>
      <div class="flex justify-center w-full">
        <ButtonLink
          :to="{ name: 'BulkSendsCreate' }"
          class="text-center"
          data-test="bulksend-button-text"
          data-ec="bulk_send_dashboard"
          data-et="empty_state_create_link"
        >
          {{ $t('ui.bulkSend.emptyState.upsellBulkSends.cta') }}
        </ButtonLink>
      </div>
    </template>
  </BaseEmptyState>
</template>

<script>
import BaseEmptyState from '@/components/library/emptyStates/BaseEmptyState.vue';
import { BulkSendIcon } from '@/components/icons/svgIcons/BulkSendIcon';
import ButtonLink from '@/components/library/links/ButtonLink.vue';

export default {
  name: 'BulkSendEmptyState',
  components: {
    BaseEmptyState,
    BulkSendIcon,
    ButtonLink,
  },
};
</script>

<style scoped>
.empty-state-icon svg {
  @apply h-eightyEight w-eightyEight !important;
}
.empty-state-content h2 {
  @apply max-w-xl;
}
.empty-state-content p {
  @apply text-16 max-w-xl;
}
.empty-state-content a {
  @apply text-white;
}
</style>
